import { useState } from 'react';
import { createPortal } from 'react-dom';
import MetaConnectionMethodCards, {
  MetaConnectionMethod,
} from './MetaConnectionMethodCards';

interface SelectFacebookTokenTypeProps {
  onSelectPersonal: () => void;
  onSelectObo: () => void;
}

const SelectFacebookTokenType = ({
  onSelectPersonal,
  onSelectObo,
}: SelectFacebookTokenTypeProps) => {
  const [redirecting, setRedirecting] = useState<MetaConnectionMethod | null>(
    null,
  );

  const handleSelect = (method: MetaConnectionMethod, onSelect: () => void) => {
    if (redirecting) {
      return;
    }
    setRedirecting(method);
    onSelect();
  };

  return (
    <div>
      <MetaConnectionMethodCards
        loading={redirecting}
        onSelectBusinessManager={() => handleSelect('obo', onSelectObo)}
        onSelectPageAdmin={() => handleSelect('personal', onSelectPersonal)}
      />

      {redirecting &&
        createPortal(
          <div
            className="tw-fixed tw-inset-0 tw-z-[9999] tw-cursor-wait"
            aria-hidden="true"
            data-cy="add-profile_fb-token-type_redirect-overlay"
          />,
          document.body,
        )}
    </div>
  );
};

export default SelectFacebookTokenType;
